function getIntersection(a?: Array<string>, b?: Array<string>): Array<string> | undefined {
  if (!a || !b) return undefined;
  const aSet = a ? new Set(a) : new Set<string>();
  const bSet = b ? new Set(b) : new Set<string>();
  return [...aSet].filter((value) => bSet.has(value));
}

function isSameSet(a?: Array<string>, b?: Array<string>): boolean {
  const aSet = a ? new Set(a) : new Set<string>();
  const bSet = b ? new Set(b) : new Set<string>();
  return aSet?.size === bSet?.size && !!a?.every((value) => bSet.has(value));
}

function isSubset(a?: Array<string>, b?: Array<string>): boolean {
  const bSet = b ? new Set(b) : new Set<string>();
  return !a || a.every((value) => bSet?.has(value));
}

function combineArrays(a?: Array<string>, b?: Array<string>): Array<string> | undefined {
  const aSet = a ? new Set(a) : undefined;
  const bSet = b ? new Set(b) : undefined;
  if (!aSet && !bSet) return undefined;
  if (!aSet) return [...bSet!];
  if (!bSet) return [...aSet];

  return [...new Set([...aSet, ...bSet])];
}

const hasUniqueElements = (array: Array<string> | undefined): boolean => {
  if (!array || array.length === 1) return true;
  return array.length === new Set(array).size;
};

const trigraphsThenTetragraphs = (array: Array<string> | undefined): boolean => {
  if (!array || array.length === 1) return true;

  const trigraphs = array.filter((value) => value.length === 3 && value !== 'USA');
  const tetragraphs = array.filter((value) => value.length === 4);

  if (trigraphs.length === 0 || tetragraphs.length === 0) return true;

  const lastTrigraph = array.indexOf(trigraphs[trigraphs.length - 1]!);
  const firstTetragraph = array.indexOf(tetragraphs[0]!);

  return lastTrigraph < firstTetragraph;
};

const usaFirst = (array: Array<string> | undefined): boolean => {
  if (!array || array.length === 1) return true;
  if (!array.includes('USA')) return true;
  return array[0] === 'USA';
};

const trigraphsTetragraphSortedAlphabetically = (array: Array<string> | undefined): boolean => {
  if (!array || array.length === 1) return true;

  const trigraphsAlphabetical = array
    .filter((value) => value.length === 3)
    .every((value, index, arr) => {
      if (index === 0) return true;
      return value >= arr[index - 1]!;
    });

  const tetragraphsAlphabetical = array
    .filter((value) => value.length === 4)
    .every((value, index, arr) => {
      if (index === 0) return true;
      return value >= arr[index - 1]!;
    });

  return trigraphsAlphabetical && tetragraphsAlphabetical;
};

const sortedAlphabetically = (array: Array<string> | undefined): boolean => {
  if (!array || array.length === 1) return true;

  return array.every((value, index, arr) => {
    if (index === 0) return true;
    return value >= arr[index - 1]!;
  });
};

const sortedNumeric = (array: Array<string> | undefined): boolean => {
  if (!array || array.length === 1) return true;

  return array.every((value, index, arr) => {
    if (index === 0) return true;
    return Number(value) >= Number(arr[index - 1]);
  });
};

export {
  combineArrays,
  getIntersection,
  hasUniqueElements,
  isSameSet,
  isSubset,
  sortedAlphabetically,
  sortedNumeric,
  trigraphsTetragraphSortedAlphabetically,
  trigraphsThenTetragraphs,
  usaFirst,
};
